import { MarketingShell } from "@/components/landing/MarketingShell";
import { SeoHead } from "@/components/useSeo";
import { MarketingLink } from "@/components/OptionalLink";
import { Boilerplate } from "@/components/landing/Boilerplate";

const Page = () => (
  <MarketingShell>
    <SeoHead
      path="boilerplate"
      title="Popular New Project Boilerplates — DollarDeploy"
      description="Ready-made starter projects and self-hostable apps. Fork, deploy, done."
    />
    <section className="container py-20 flex flex-col gap-10">
      <Boilerplate landing />

      <div className="text-center pb-16">
        <MarketingLink
          href="/r"
          className="inline-block border rounded-full px-6 py-3 text-sm font-medium hover:bg-foreground hover:text-background hover:border-foreground transition-colors"
        >
          Browse all templates →
        </MarketingLink>
      </div>
    </section>
  </MarketingShell>
);

export default Page;
